import { render, staticRenderFns } from "./TTCPriceField.vue?vue&type=template&id=1cc0564b&"
import script from "./TTCPriceField.vue?vue&type=script&lang=js&"
export * from "./TTCPriceField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports